<template>
    <div>
      <div class="table-toolbar d-flex justify-content-between align-items-center mb-3">
        <div class="toolbar-left">
          <select
            v-model="selectedErrorType"
            @change="onErrorTypeChange"
            class="form-control form-control-sm"
            style="width: auto; display: inline-block; margin-right: 10px;"
          >
            <option value="">Semua Tipe Error</option>
            <option value="blacklist">Blacklist</option>
            <option value="rule">Rule</option>
            <option value="jam_kerja">Jam Kerja</option>
            <option value="quota">Quota</option>
            <option value="human_takeover">Human Takeover</option>
            <option value="api_error">API Error</option>
            <option value="validation">Validation</option>
          </select>
        </div>
      </div>
      
      <vue-good-table
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="table.total_records"
        :isLoading.sync="table.isLoading"
        :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }"
        :columns="table.columns"
        :rows="table.rows"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'error_type'">
            <span :class="getErrorTypeBadgeClass(props.row.error_type)">
              {{ formatErrorType(props.row.error_type) }}
            </span>
          </span>
          <span v-else-if="props.column.field == 'details'">
            <button
              v-if="props.row.details"
              class="btn btn-sm btn-info"
              @click="showDetails(props.row)"
            >
              Lihat Detail
            </button>
            <span v-else>-</span>
          </span>
          <span v-else-if="props.column.field == 'message'">
            {{ truncateText(props.formattedRow[props.column.field], 25) }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <!-- Modal for details -->
      <modal name="error-details" :height="'auto'" :adaptive="true" :scrollable="true">
        <div style="margin: 20px">
          <h5>Error Details</h5>
          <pre style="background: #f5f5f5; padding: 15px; border-radius: 5px; overflow-x: auto;">{{ errorDetails }}</pre>
          <button class="btn btn-secondary mt-3" @click="$modal.hide('error-details')">Tutup</button>
        </div>
      </modal>
    </div>
  </template>
  
  <script>

  export default {
    props: ['id'],
    data() {
      return {
        selectedErrorType: '',
        errorDetails: '',
        table: {
          total_records: 0,
          isLoading: true,
          columns: [
            {
              label: "Tanggal",
              field: "created_at",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Nomor",
              field: "number",
              filterOptions: {
                enabled: true,
                filterTrigger: 'auto',
                placeholder: 'Cari nomor...',
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Tipe Error",
              field: "error_type",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Error Code",
              field: "error_code",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Pesan",
              field: "message",
              filterOptions: {
                enabled: true,
                filterTrigger: 'auto',
                placeholder: 'Cari...',
              },
              sortable: false,
              width: "25%",
            },
            {
              label: "Detail",
              field: "details",
              sortable: false,
              width: "15%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [
              {
                field: "",
                type: "",
              },
            ],
            page: 1,
            limit: 10,
          },
        },
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      onErrorTypeChange() {
        this.table.serverParams.page = 1;
        this.loadItems();
      },
      showDetails(row) {
        try {
          this.errorDetails = JSON.stringify(JSON.parse(row.details), null, 2);
        } catch (e) {
          this.errorDetails = row.details;
        }
        this.$modal.show('error-details');
      },
      formatErrorType(type) {
        const types = {
          'blacklist': 'Blacklist',
          'rule': 'Rule',
          'jam_kerja': 'Jam Kerja',
          'quota': 'Quota',
          'human_takeover': 'Human Takeover',
          'api_error': 'API Error',
          'validation': 'Validation'
        };
        return types[type] || type;
      },
      getErrorTypeBadgeClass(type) {
        const classes = {
          'blacklist': 'badge badge-danger',
          'rule': 'badge badge-warning',
          'jam_kerja': 'badge badge-info',
          'quota': 'badge badge-danger',
          'human_takeover': 'badge badge-secondary',
          'api_error': 'badge badge-danger',
          'validation': 'badge badge-warning'
        };
        return classes[type] || 'badge badge-secondary';
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign(
          {},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({page: params.currentPage});
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({limit: params.currentPerPage});
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [
            {
              type: params.sortType,
              field: this.table.columns[params.columnIndex].field,
            },
          ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.table.serverParams.columnFilters = params.columnFilters || {};
        this.table.serverParams.page = 1;
        this.loadItems();
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records;
          this.table.rows = response.data.data.error_logs.map(item => ({
            ...item,
            created_at: this.formatDate(item.created_at),
            error_code: item.error_code || '-'
          }));
        } catch (err) {
          this.$toast.error("Gagal memuat error logs");
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
        const params = {
          id: this.id,
          ...param,
          error_type: this.selectedErrorType || undefined
        };
        return await this.$store.dispatch("chatgpt_error_log_list", params);
      },
      formatDate(timestamp) {
        if (!timestamp) return '-';
        const date = new Date(timestamp);
        return date.toLocaleString('id-ID', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      },
      truncateText(text, maxLength) {
        if (!text) return '-';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
      }
    },
  };
  </script>
  
  <style scoped>
  .margin5 {
    margin: 5px;
  }

  .table-toolbar {
    padding: 4px 0 8px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  </style>



